import { Suspense } from 'react';
import styled from 'styled-components';
import Spinner from 'components/spinner';
import Logo from 'assets/images/logo.svg';
import AuthProvider from './auth-provider';
import AppRoutes from './routes';

const SiteWrapper = styled.div`
  padding: 30px;
`;

export const App = () => {
  // const [isRapNetLogo, setisRapNetLogo] = useState(false);

  return (
    <Suspense fallback={<Spinner />}>
      <SiteWrapper>
        {/* {isRapNetLogo ? (
        <img alt="rapaport" src={Logo} />

        ) : (
          
        )} */}

        <img alt="rapaport" src={Logo} />
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </SiteWrapper>
    </Suspense>
  );
};
